import { TFunction } from 'i18next';

/** i18n path for a template title, e.g. system.emails.templateKeys.auth.forgotPassword */
function emailTemplateTitleKey(templateKey: string): string {
  return `system.emails.templateKeys.${templateKey}`;
}

function emailTemplateHelpKey(templateKey: string): string {
  return `system.emails.templateHelp.${templateKey}`;
}

export function translateEmailTemplateTitle(
  t: TFunction,
  templateKey: string,
  fallback?: string,
): string {
  return t(emailTemplateTitleKey(templateKey), { defaultValue: fallback ?? templateKey });
}

export function translateEmailTemplateHelp(
  t: TFunction,
  templateKey: string,
  fallback?: string,
): string {
  return t(emailTemplateHelpKey(templateKey), { defaultValue: fallback ?? '' });
}
